import { render } from "./MissionGamePuzzle.vue?vue&type=template&id=1af06a49&scoped=true"
import script from "./MissionGamePuzzle.vue?vue&type=script&lang=js"
export * from "./MissionGamePuzzle.vue?vue&type=script&lang=js"

import "./MissionGamePuzzle.vue?vue&type=style&index=0&id=1af06a49&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af06a49"]])

export default __exports__